import {SectionCover} from './SectionCover';
import coverImage from '../../../../assets/pdf/sections/two.png';

// This is called section cover 2, because in the designs it's the second section cover
// but there isn't one for the first section
export const SectionCoverTwo = () => {
  return <SectionCover sectionTitle={'sectionPages.two'} coverImage={coverImage} />;
};
